import React, { useEffect, useState } from 'react';
import { FunctionColor, BrandColor } from '@lux/core';
import { Preset, Text } from '@lux/text';
import { ControlsCheck, ControlsArrowsNext } from '@lux/icons';
import { Translate } from '@pegasus/translation';
import { checkIsCrossCampaignTrackingProperty } from '@browsing/tracking';
import { tracker } from '../../tracking';
import * as S from './Category.styles';
var MAX_DEPTH = 2;
export var Category = function (_a) {
    var category = _a.category, depth = _a.depth, availableCategoriesSet = _a.availableCategoriesSet, selectedCategoriesSet = _a.selectedCategoriesSet, campaignId = _a.campaignId, selectedPath = _a.selectedPath, toggleSelection = _a.toggleSelection, isCrossCampaign = _a.isCrossCampaign, isMyLoungeCrossCampaign = _a.isMyLoungeCrossCampaign;
    if (!(category === null || category === void 0 ? void 0 : category.id)) {
        return null;
    }
    if (depth < selectedPath.length - 1 &&
        depth < MAX_DEPTH &&
        !selectedPath.includes(category.id)) {
        return null;
    }
    var inSelectedPath = selectedPath.includes(category.id);
    var isAvailable = availableCategoriesSet.has(category.id);
    var isSelected = selectedCategoriesSet.has(category.id);
    var _b = useState(depth < MAX_DEPTH && inSelectedPath), showChildren = _b[0], updateShowChildren = _b[1];
    useEffect(function () {
        if (!showChildren && depth < MAX_DEPTH && inSelectedPath) {
            updateShowChildren(true);
        }
    }, [selectedPath]);
    var onClick = function () {
        var _a;
        var _b;
        if (depth < MAX_DEPTH) {
            toggleSelection(showChildren ? category.parentId : category.id, depth + 1, showChildren);
            updateShowChildren(!showChildren);
            if (!isMyLoungeCrossCampaign) {
                tracker.track(showChildren ? 'catalog_filterCategory_less' : 'catalog_filterCategory_more', (_a = {
                        productCampaign: campaignId,
                        component: "Level".concat(depth + 1),
                        items: (_b = category.categories) === null || _b === void 0 ? void 0 : _b.length
                    },
                    _a["campaign_level_".concat(depth + 2)] = String(category.id),
                    _a["campaign_level_".concat(depth + 3)] = (category.categories || [])
                        .map(function (x) { return x.id; })
                        .join(';'),
                    _a.crossCampaignFilter = checkIsCrossCampaignTrackingProperty(isCrossCampaign),
                    _a));
            }
        }
        else {
            toggleSelection(category.id, depth + 1, showChildren);
        }
    };
    var onSelectAllBtnClick = function () {
        if (!selectedCategoriesSet.has(category.id)) {
            toggleSelection(category.id, depth + 1, showChildren);
        }
    };
    return (React.createElement("div", null,
        React.createElement(S.StyledButton, { onClick: onClick, isExpanded: showChildren && depth < MAX_DEPTH, isNested: showChildren && depth < MAX_DEPTH - 1 && selectedPath.length > 2, disabled: !isAvailable, type: "button", "aria-pressed": isSelected },
            React.createElement(Text, { bold: depth === MAX_DEPTH && (isSelected || selectedPath.includes(category.id)), preset: Preset.S, color: 
                // eslint-disable-next-line no-nested-ternary
                showChildren && depth < MAX_DEPTH
                    ? FunctionColor.function60
                    : isSelected ||
                        (depth === MAX_DEPTH && selectedPath.includes(category.id))
                        ? BrandColor.primary
                        : FunctionColor.function100 }, category.name),
            category.categories && depth < MAX_DEPTH && (React.createElement(React.Fragment, null, showChildren ? (React.createElement(S.ShowLessIconWrapper, null,
                React.createElement(ControlsArrowsNext, { color: FunctionColor.function100 }))) : (React.createElement(S.ShowMoreIconWrapper, null,
                React.createElement(ControlsArrowsNext, { color: FunctionColor.function100 }))))),
            isSelected && depth === MAX_DEPTH && React.createElement(ControlsCheck, { color: BrandColor.primary })),
        React.createElement(S.List, null,
            showChildren && (depth === selectedPath.length - 2 || depth === MAX_DEPTH - 1) && (React.createElement("li", null,
                React.createElement(S.StyledButton, { onClick: onSelectAllBtnClick, type: "button", "aria-pressed": isSelected },
                    React.createElement(Text, { bold: isSelected, preset: Preset.S, color: isSelected ? BrandColor.primary : FunctionColor.function100 },
                        React.createElement(Translate, { message: "filters.allIn", params: { category: category.name } })),
                    isSelected && React.createElement(ControlsCheck, { color: BrandColor.primary })))),
            showChildren &&
                category.categories &&
                category.categories
                    .sort(function (a, b) {
                    return Number(availableCategoriesSet.has(b.id)) -
                        Number(availableCategoriesSet.has(a.id));
                })
                    .map(function (c) { return (React.createElement("li", { key: c.id },
                    React.createElement(Category, { campaignId: campaignId, category: c, depth: depth + 1, availableCategoriesSet: availableCategoriesSet, selectedCategoriesSet: selectedCategoriesSet, toggleSelection: toggleSelection, selectedPath: selectedPath, parentCategory: category, isCrossCampaign: isCrossCampaign, isMyLoungeCrossCampaign: isMyLoungeCrossCampaign }))); }))));
};
export default Category;
